import { Route, Routes, BrowserRouter } from "react-router-dom";
import ProtectedRoute from './ProtectedRoute';
import AppRoutes from "./AppRoutes";
import { isLaunchEnabledPath } from "./launchScope";
import ReleaseUnavailable from "../Screens/ReleaseUnavailable";

export default function AdminRouter() {
  return (
    <BrowserRouter>
      <Routes>
        {
          AppRoutes.filter(item => !item.isProtected).map((item, index) => (
            <Route key={index} path={item.path} element={item.element} />
          ))
        }
        {
          AppRoutes.filter(item => item.isProtected).map((item, index) => (
            <Route
              key={index}
              path={item.path}
              element={
                <ProtectedRoute>
                  {isLaunchEnabledPath(item.path) ? item.element : <ReleaseUnavailable />}
                </ProtectedRoute>
              }
            />
          ))
        }
      </Routes >
    </BrowserRouter>
  );
}
